import { PRIVATE_ROUTES } from '../../routes'

export const REPORTING_DATE_DISPLAY_FORMAT = 'DD-MM-YYYY'

/** Shared screen breakpoints for reporting modules (px). */
export const REPORTING_SCREEN = {
    XL: 1440,
    LG: 1280,
    MD: 1200,
    SM: 992,
    XS: 768,
    XXS: 480,
}

export const REPORTING_REPORTS = [
    {
        key: 'workload',
        title: 'Workload',
        description:
            'User workload and time logged across projects with team member breakdown.',
        icon: 'mdi:account-clock-outline',
        route: PRIVATE_ROUTES.reportingWorkload,
        available: true,
    },
    {
        key: 'project-capacity',
        title: 'Project Capacity',
        description:
            'Team workload, resource allocation, and capacity planning across projects.',
        icon: 'mdi:chart-gantt',
        route: PRIVATE_ROUTES.reportingProjectCapacity,
        available: true,
    },
]
